import { VdsIcon } from '@volt/volt-extended-components-react';
import { ReactElement } from 'react';
import styles from './AssetNameMismatchCellRenderer.module.scss';

interface AssetNameMismatchCellRendererProps {
  value: string;
}

export function AssetNameMismatchCellRenderer({
  value,
}: AssetNameMismatchCellRendererProps): ReactElement {
  return (
    <div className={styles.nameMismatch}>
      <VdsIcon size="22px" svgIcon="information" color="red-500" />
      {value}
    </div>
  );
}

export default AssetNameMismatchCellRenderer;
